import { Button, Dialog, DialogActions, DialogContent, DialogHeading, Typography } from 'omakase';
import { FunctionComponent } from 'react';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';

interface GiftCardBalanceDialogProps {
  isOpen: boolean;
  onClose(): void;
  balanceCents: number;
  /**
   * used for testing only, see guides for ssr on modal on material ui site.
   */
  ssr?: boolean;
}

const DIALOG_TITLE = 'gift-card-dialog-title';
const DIALOG_CONTENT = 'gift-card-dialog-content';

export const GiftCardBalanceDialog: FunctionComponent<GiftCardBalanceDialogProps> = ({
  isOpen,
  onClose,
  balanceCents,
  ssr = false,
}) => {
  return (
    <>
      <Dialog
        variant="sheet"
        aria-labelledby={DIALOG_TITLE}
        aria-describedby={DIALOG_CONTENT}
        open={isOpen}
        onClose={onClose}
        disablePortal={ssr}
      >
        <DialogHeading onClose={onClose}>Welcome back!</DialogHeading>
        <DialogContent id={DIALOG_CONTENT} dividers={false}>
          <Typography id={DIALOG_TITLE} variant="heading03" color="fgDefault" component="h3" mb={2}>
            You have a <ConsumerDisplayMoney amount={balanceCents} /> gift card balance.
          </Typography>
          <Typography variant="body02" paragraph>
            Use your gift card balance at participating businesses on Tock. Just apply it at
            checkout.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button href="/profile/account/gift-cards" variant="ghost" size="large" onClick={onClose}>
            Learn more
          </Button>
          <Button variant="primary" size="large" onClick={onClose}>
            Sounds good
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
